import { SnackbarProvider } from 'notistack';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// contexts
import { AuthProvider } from './contexts/AuthContext';
// components
import ThemeSettings from './components/settings';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import MotionLazyContainer from './components/animate/MotionLazyContainer';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <AuthProvider>
      <MotionLazyContainer>
        <ThemeProvider>
          <ThemeSettings>
            <SnackbarProvider
              maxSnack={3}
              autoHideDuration={3500}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
              <ProgressBarStyle />
              <ScrollToTop />
              <Router />
            </SnackbarProvider>
          </ThemeSettings>
        </ThemeProvider>
      </MotionLazyContainer>
    </AuthProvider>
  );
}
